import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import loaderImg from '../../assets/loaderWhite.gif'

function Loader() {
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
  
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000}}
        open={open}
    
      >
     <img src={loaderImg} width={400} alt='loading...'/>
      </Backdrop>
    </div>
  );
}
export default  Loader